import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import moment from 'moment';
import PageTemplate from "./PageTemplate";


class Overview extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
    this.state = {
      showMainPage: true,
      showFilter: false,
      showValue: '',
      showTabView: 2

    }
  }

  componentDidMount() {

  }


  exportPDFWithComponent = () => {
    if (this.pdfExportComponent.current) {
      this.pdfExportComponent.current.save();
    }
  };


  closeFilter = (check1, check2) => {
    this.setState({ showFilter: check1, showValue: check2 });
  }

  openSurveyResponse = () => {
    this.setState({ showOverview: false });

  }

  closeResponseAnalytics = () => {
    this.setState({ showOverview: true })
  }

  onOptionType = (value) => {
    this.setState({ optionType: value })
  }


  handleStrength = (params) => {
    let { handleThemeStrenght } = this.props;
    let { FilterValues } = this.state;
    let name = ''
    if (params && params.name) {
      name = params.name;
    }
    handleThemeStrenght(name, FilterValues);
    this.setState({ showMainPage: false })
  }


  handleMultifilterIndexScore2 = (finalFilter, name) => {

    let { handlAssessmentDashboard } = this.props;
    this.setState({
      FilterValues: finalFilter,
      ListName: name,
      showMainPage: true
    });

    handlAssessmentDashboard(finalFilter, true);

  }

  handleGOTOTheme = () => {
    this.setState({ showMainPage: true })
  }

  handleTabView = (value) => {
    this.setState({ showTabView: value })
  }

  render() {

    let { loading, getAssessmentDimensionsData, EditButtonFn, EditDetailsFn } = this.props;
    let { showMainPage, showTabView } = this.state;


    function spliceDecimal(no) {
      if (no) {
        let str = no.toString();
        let first = str.split('.')[0];
        let second = str.split('.')[1];
        let second2 = second ? second.substring(0, 2) : ""
        let final = first + '.' + second2;
        if (second2) {
          return parseFloat(final).toFixed(2)
        } else {
          return no
        }
      } else {
        return 0
      }
    }



    console.log("getAssessmentDimensionsData----->", getAssessmentDimensionsData)



    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }




    let AssessmentList = []
    if (getAssessmentDimensionsData && getAssessmentDimensionsData.length > 0) {
      AssessmentList = getAssessmentDimensionsData;
    }
    console.log("AssessmentList--1->", AssessmentList)


    let newList = []
    if (AssessmentList && AssessmentList.length > 0) {
      AssessmentList.forEach((element, index) => {

        let rank = (index + 1);
        // let rank = (AssessmentList.length - index);

        let check = 0;
        if (showTabView === 1) {
          check = 1
        } else if (showTabView === 2 && (rank <= 5)) {
          check = 2
        } else if (showTabView === 3 && (rank <= 7)) {
          check = 3
        } else if (showTabView === 4 && (rank <= 10)) {
          check = 4
        }
        console.log("check--1->", check)

        let getIndex = newList.findIndex(prev => prev.bucket === element.bucket)
        if (getIndex === -1) {
          let temp = {
            "showCount": 0,
            "bucket": element.bucket,
            "colorCode": element.colorCode,
            "dimensions": [{
              "rank": rank,
              "check": check,
              "name": element.dimension,
              "count": element.count,
              "finalSum": element.finalSum,
              "colorCode": element.colorCode,
            }],
          }
          newList.push(temp)
        } else {
          newList[getIndex]["showCount"] += 1

          newList[getIndex]["dimensions"].push({
            "rank": rank,
            "check": check,
            "name": element.dimension,
            "count": element.count,
            "finalSum": element.finalSum,
            "colorCode": element.colorCode,
          })
        }



      });
    }


    let newV2List = [];
    if (newList && newList.length > 0) {
      for (var ix = 0; ix < newList.length; ix++) {
        let details = newList[ix];
        let temp = details;
        if (details && details.dimensions && details.dimensions.length > 0) {
          temp["dimensions"] = details.dimensions.sort((a, b) => (a.rank - b.rank));
        }
        newV2List.push(temp)
      }
    }


    function getLightColor(bucket) {
      let obj = {
        "THINKING TALENTS": "#FFF0C4",
        "ACTING TALENTS": "#CAE6FC",
        "LEADING TALENTS": "#DBD0EE",
        "RELATING TALENTS": "#D4ECD5"
      }
      return obj && obj[bucket] ? obj[bucket] : "#F2F2F2"
    }

    let xsList = getAssessmentDimensionsData;
    function getElements(value, type, list) {
      if (list && list.length > 0) {
        if (type === "dimension") {
          const index = list.findIndex(
            item => item.dimension === value
          );
          return index !== -1 ? list[index] : {};
        } if (type === "bucket") {
          const index = list.findIndex(
            item => item.bucket === value
          );
          return index !== -1 ? list[index] : {};
        } else {
          return {}
        }
      } else {
        return {}
      }
    }


    return (
      <>

        <div className="w-full mt-4" >

          <div className="grid grid-cols-1 gap-4 md:grid-cols-1 ">

            <div className="p-6 bg-white border shadow-sm rounded-xl">

              <div className='flex pt-2 pb-6'>
                <h1 className="text-xl font-bold text-gray-800 md:font-semibold md:text-2xl">
                  {EditButtonFn('YourTalentPlusThemesByDomain', "Dominant TalentPlus theme")}
                </h1>
              </div>

              <PDFExport ref={this.pdfExportComponent}
                pageTemplate={(pageObj) => <PageTemplate pageNum={pageObj.pageNum} />}
                scale={0.6}
                forcePageBreak=".page-break"
                paperSize="A4"
                margin={0}
                fileName={`Assessment Dominant Themes - ${moment(Date.now()).format("DD/MM/YYYY")}`}

                author="Happyplus Team"
                landscape={true}
              >

                <div dir="rtl" className="grid grid-cols-1 gap-4 md:grid-cols-4">

                  {newList && newList.length > 0
                    ? newList.map((item) => (
                      <div className="">
                        <div className="">
                          <div
                            className={`px-2 py-2 mb-1.5 font-semibold bg-[#F2F2F2] flex justify-center col-span-2 space-x-2 textcolor`}
                          >
                            <span>{EditDetailsFn(getElements((item.bucket.toString()).trim(), "bucket", xsList), "bucket", (item.bucket.toString()).trim())}</span>
                          </div>

                          {item && item.dimensions && item.dimensions.length > 0
                            ? item.dimensions.map((element, index2) => (
                              <>

                                {element && element.rank && element.rank <= 5 ? (
                                  <div className="pr-6 pb-1">
                                    <div
                                      className="relative flex items-center py-3 bg-[#FFC400] text-black font-semibold text-lg pr-16 pl-12 w-full"
                                      style={{
                                        background: hexToRgbA(
                                          item && item.colorCode ? item.colorCode : "#DDDDDD",
                                          element.rank <= 5 ? "1.0" : "0.24"
                                        ),
                                        color:
                                          element.rank <= 5
                                            ? item.bucket.trim() === "THINKING TALENTS"
                                              ? "#3D405B"
                                              : "#FFFFFF"
                                            : "#3D405B",
                                      }}
                                    >
                                      <div className="absolute right-0 top-1/2 -translate-y-1/2 -mr-6">
                                        <div
                                          className="w-14 h-14 bg-[#FFC400] rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white"
                                          style={{
                                            background: hexToRgbA(
                                              item && item.colorCode ? item.colorCode : "#DDDDDD",
                                              element.rank <= 5 ? "1.0" : "0.24"
                                            ),
                                            color:
                                              element.rank <= 5
                                                ? item.bucket.trim() === "THINKING TALENTS"
                                                  ? "#3D405B"
                                                  : "#FFFFFF"
                                                : "#3D405B",
                                          }}
                                        >
                                          {element.rank}
                                        </div>
                                      </div>
                                      {EditDetailsFn(getElements(element.name, "dimension", xsList), "dimension", element.name)}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="pr-6 pb-1">
                                    <div
                                      style={{
                                        background: getLightColor(item.bucket),
                                      }}
                                      className={`relative flex items-center py-3 text-black font-semibold text-lg pr-16 pl-12 w-full`}
                                    >
                                      <div className="absolute right-0 top-1/2 -translate-y-1/2 -mr-6">
                                        <div
                                          style={{
                                            background: getLightColor(item.bucket),
                                          }}
                                          className={`w-14 h-14 rounded-full flex items-center justify-center text-black font-bold text-base border-4 border-white`}
                                        >
                                          {element.rank}
                                        </div>
                                      </div>
                                      {EditDetailsFn(getElements(element.name, "dimension", xsList), "dimension", element.name)}
                                    </div>
                                  </div>
                                )}
                              </>
                            ))
                            : null}
                        </div>
                      </div>
                    ))
                    : null}
                </div>




                {!(newV2List && newV2List.length > 0) ?
                  <>
                    {!loading ?
                      <div className="pt-16 pb-24 text-center text-xl text-[#3d405B]/70">No Data Available</div>
                      : null}
                  </>
                  : null}



              </PDFExport>

            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  // ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(Overview);
